/**
 * Footer menu dropdown behavior
 */
((Drupal, once) => {
  'use strict';

  Drupal.behaviors.tpFooterDropdown = {
    attach(context: Document | HTMLElement) {
      const toggleButtons = once('tp-footer-toggle', '.tp-footer__submenu-toggle', context);

      if (toggleButtons.length <= 0) {
        return;
      }

      const handleClick = (event: Event, toggleBtn: HTMLButtonElement) => {
        event.preventDefault();

        const listItem = toggleBtn.closest('li');
        const submenu = listItem?.querySelector<HTMLElement>('.tp-footer__submenu-level');

        if (!submenu) {
          return;
        }

        const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';

        // Toggle states
        toggleBtn.setAttribute('aria-expanded', String(!isExpanded));

        if (isExpanded) {
          submenu.classList.add('is-collapsed');
          submenu.classList.remove('is-expanded');
        } else {
          submenu.classList.remove('is-collapsed');
          submenu.classList.add('is-expanded');
        }
      };

      toggleButtons.forEach((button) => {
        const toggleBtn = button as HTMLButtonElement;
        toggleBtn.addEventListener('click', (event) => handleClick(event, toggleBtn));
      });
    },
  };
})(Drupal, once);
